import { BrandLogo } from '@calendly/ui/components/brand-logo';
import classNames from 'classnames';
import { forwardRef } from 'react';
const logoWrapperBaseCss = "l1f82irh";
const connectButtonLogoWrapperCss = "c9tf51d";
const connectButtonGmailLogoWrapperCss = "cvdtavq";
const dropdownLogoWrapperCss = "d1hsmhrm";
export const SendFromBrandLogo = forwardRef(({
  name,
  title,
  className,
  wrapperCss = connectButtonLogoWrapperCss,
  ...props
}, ref) => <span ref={ref} className={classNames(logoWrapperBaseCss, wrapperCss, className)}>
    <BrandLogo name={name} title={title} {...props} />
  </span>);
export const SendFromGmailLogo = forwardRef((props, ref) => <SendFromBrandLogo ref={ref} name="gmail" title="Gmail" wrapperCss={connectButtonGmailLogoWrapperCss} {...props} />);
export const SendFromOutlookLogo = forwardRef((props, ref) => <SendFromBrandLogo ref={ref} name="microsoft-outlook" title="Outlook" {...props} />);
export const SendFromDropdownGmailLogo = forwardRef((props, ref) => <SendFromBrandLogo ref={ref} name="gmail" title="Gmail" wrapperCss={dropdownLogoWrapperCss} {...props} />);
export const SendFromDropdownOutlookLogo = forwardRef((props, ref) => <SendFromBrandLogo ref={ref} name="microsoft-outlook" title="Outlook" wrapperCss={dropdownLogoWrapperCss} {...props} />);
export const SendFromDropdownBrandLogo = forwardRef((props, ref) => <SendFromBrandLogo ref={ref} wrapperCss={dropdownLogoWrapperCss} {...props} />);

require("./send_from_brand_logo.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./send_from_brand_logo.js");